import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/agent-rules")({
  component: lazyRouteComponent(() => import("./-pages/admin.agent-rules")),
  head: () => ({
    meta: [
      { title: "Agent Rules · Lecmo Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
